<template>
    <div id="main" ref="main">
        <div class="wrapper-header">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="wrapper-logo">
                            <a  target="_blank" href="http://minarental.com/">
                                <img src="/logo.png" alt="">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
        <div class="wrapper-slider">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="wrapper-title">
                            <h2>Car Rental</h2>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" >
                        <p style="text-align:center">
                            {{$store.state.content_carental}}
                        </p>
                        <carousel id="slider-car" :lazyLoad="true" :autoplay="true" :nav="false" :items="items" :responsiveClass="true" :responsive="responsive">
                            <div class="slider-item pd-15 sl-50"  v-for="(data,index) in DataMain" :key="index">
                               <div class="slider-image">
                                   
                                    <img :src="data[0]" :alt="data[1]">
                                     <a :href="data[2]" target="_blank"><div class="slider-effect"></div> </a>
                                </div>
                                <div class="slider-content">
                                    <div class="slider-name">
                                        <a target="_blank" :href="data[2]">
                                            {{data[1]}}
                                        </a>
                                    </div>
                                    <div class="slider-desc">
                                        {{data[3]}}
                                    </div>
                                    <div class="slider-readmore">
                                        <a target="_blank" :href="data[2]">
                                            Read more
                                            <i class="fas fa-chevron-right"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </carousel>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrapper-slider">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="wrapper-title">
                            <h2>AirBnB</h2>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" >
                        <p style="text-align:center">
                            {{$store.state.content_aribnb}}
                        </p>
                        <carousel id="slider-car" :lazyLoad="true" :autoplay="true" :nav="false" :items="items" :responsiveClass="true" :responsive="responsive">
                            <div class="slider-item pd-15 sl-50"  v-for="(data,index) in DataMain" :key="index" v-if="data[4]">
                               <div class="slider-image">
                                    <img :src="data[4]" :alt="data[5]">
                                     <a :href="data[6]" target="_blank"><div class="slider-effect"></div></a>
                                </div>
                                <div class="slider-content">
                                    <div class="slider-name">
                                        <a target="_blank" :href="data[6]">
                                            {{data[5]}}
                                        </a>
                                    </div>
                                    <div class="slider-desc">
                                        {{data[7]}}
                                    </div>
                                    <div class="slider-readmore">
                                        <a target="_blank" :href="data[6]">
                                            Read more
                                            <i class="fas fa-chevron-right"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </carousel>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrapper-slider">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="wrapper-title">
                            <h2>Portfolio</h2>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" >
                        <p style="text-align:center">
                            {{$store.state.content_portfolio}}
                        </p>
                        <carousel id="slider-car" :lazyLoad="true" :autoplay="true" :nav="false" :items="items" :responsiveClass="true" :responsive="responsive">
                            <div class="slider-item pd-15 sl-50"  v-for="(data,index) in DataMain" :key="index" v-if="data[10]">
                               <div class="slider-image">
                                    <img :src="data[10]" :alt="data[11]">
                                     <a :href="data[12]" target="_blank"><div class="slider-effect"></div></a>
                                </div>
                                <div class="slider-content">
                                    <div class="slider-name">
                                        <a target="_blank" :href="data[12]">
                                            {{data[11]}}
                                        </a>
                                    </div>
                                    <div class="slider-desc">
                                        {{data[13]}}
                                    </div>
                                    <div class="slider-readmore">
                                        <a  target="_blank" :href="data[12]">
                                            Read more
                                            <i class="fas fa-chevron-right"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </carousel>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrapper-slider">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="wrapper-title">
                            <h2>Ventures</h2>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" >
                        <p style="text-align:center">
                            {{$store.state.content_ventures}}
                        </p>
                        <carousel id="slider-car" :lazyLoad="true" :autoplay="true" :nav="false" :items="items" :responsiveClass="true" :responsive="responsive">
                            <div class="slider-item pd-15 sl-50"  v-for="(data,index) in DataMain" :key="index" v-if="data[15]">
                               <div class="slider-image">
                                    <img :src="data[15]" :alt="data[16]">
                                     <a :href="data[17]" target="_blank"><div class="slider-effect"></div></a>
                                </div>
                                <div class="slider-content">
                                    <div class="slider-name">
                                        <a target="_blank" :href="data[17]">
                                            {{data[16]}}
                                        </a>
                                    </div>
                                    <div class="slider-desc">
                                        {{data[18]}}
                                    </div>
                                    <div class="slider-readmore">
                                        <a target="_blank" :href="data[17]">
                                            Read more
                                            <i class="fas fa-chevron-right"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </carousel>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import {mapGetters} from 'vuex'
export default {
    components: {
        carousel
    },
    data()
    {
        return {
            items: 2,
            responsive: {
                0: {
                items: 1,
                },
                600: {
                    items: 1,
                },
                991: {
                    items: 2
                }
            }
        }
    },
    computed: {
        ...mapGetters(["DataMain"])
    },
    created() {
        
        this.$store.state.loading = 'active'
        this.$store.dispatch('fetchDataMain')
        .then((response) => {
            this.$store.state.loading = ''
        })
        .catch(() => {
            this.$store.state.loading = ''
        })
    },
    mounted() {
        if(this.$refs.main.clientWidth < 900)
        {
            this.items = 1
        }
    },
}
</script>